// Hook - oznaczenie wszystkich aktywnych sygnalow klienta jako rozwiazane
// POST /api/ui/trader/insights/clients/{clientId}/signals/resolve-all

import { axios } from 'api';
import { useMutation, UseMutationOptions } from 'react-query';
import { ICommandResponseError as IError, ICommandResponseSuccess } from 'api/types';
import type { IPostResolveAllClientSignalsRequest } from 'api/types/traderInsights';

export interface IPostResolveAllClientSignalsVariables {
  clientId: number;
  data?: IPostResolveAllClientSignalsRequest;
}

type IResponse = ICommandResponseSuccess;

const postResolveAllClientSignals = ({
  clientId,
  data,
}: IPostResolveAllClientSignalsVariables): Promise<IResponse> =>
  axios.post(`/trader/insights/clients/${clientId}/signals/resolve-all`, data ?? {});

export const usePostResolveAllClientSignals = (
  options?: UseMutationOptions<IResponse, IError, IPostResolveAllClientSignalsVariables>
) =>
  useMutation(
    (variables: IPostResolveAllClientSignalsVariables) => postResolveAllClientSignals(variables),
    options
  );
